import type { ReactNode } from 'react';
import { Button } from '@/components/ui/Button/Button';
import './ComboEmptyCreatePanel.css';

export type ComboEmptyCreateAction = {
  id: string;
  label: ReactNode;
  onSelect: () => void;
  disabled?: boolean;
};

export interface ComboEmptyCreatePanelProps {
  actions: ComboEmptyCreateAction[];
  hint?: string;
}

/** Пустой поиск в комбо: «Нет результатов» + primary-кнопки размера пункта дропдауна. */
export function ComboEmptyCreatePanel({
  actions,
  hint = 'Нет результатов',
}: ComboEmptyCreatePanelProps) {
  return (
    <div className="combo-empty-create" role="listbox">
      <div className="combo-empty-create__hint" role="status">
        {hint}
      </div>
      {actions.length > 0 ? (
        <div className="combo-empty-create__actions">
          {actions.map((action) => (
            <Button
              key={action.id}
              type="button"
              variant="primary"
              fullWidth
              className="combo-empty-create__btn"
              disabled={action.disabled}
              onMouseDown={(e) => {
                e.preventDefault();
                if (!action.disabled) action.onSelect();
              }}
            >
              {action.label}
            </Button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
